import { NewsfeedType } from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

export const updateListNewsFeedId = createAction(
  '[ProductList] Update ProductList News Feed Id',
  props<{ listId?: string; newsfeedId?: string; newsfeedType: NewsfeedType }>(),
);
